module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Foreword"
    }
  }, [_c('i', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_c('b', [_vm._v("Chapter 1")]), _vm._v("          Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_c('b', [_vm._v("Chapter 2")]), _vm._v("          Locomotive numbers 111–4099")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 3")]), _vm._v("          Locomotive numbers 5000–5042")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 4")]), _vm._v("          Locomotive numbers 5043–5070")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 5")]), _vm._v("          Locomotive numbers 5071–5099")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 6")]), _vm._v("          Locomotive numbers 7000–7037")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("Every effort has been made in respect of ensuring that the information given is as accurate as possible regarding the details concerning locomotive withdrawal, double chimney fitting and the dates and locations of final disposal, in respect of the 171 ‘Castle’ class engines. However, some of the previously published records do contain very minor variations in that regard, and they were understandably difficult to conclusively resolve, given the obvious passage of time")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 63
// module chunks = 0